import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { IPainelImplantacaoBody } from "../../../../Interfaces/Vendas/PainelImplantacao/PainelImplantacaoInterface";

interface IPainelImplantacaoFiltroProps {
    handleSubmit: (filter: IPainelImplantacaoBody) => void;
    defaultFilter?: IPainelImplantacaoBody;
    inicialyOpenned: boolean;
    loading: boolean;
}

export default function PainelImplantacaoFiltro(
    props: IPainelImplantacaoFiltroProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();

    return (
        <StickyToolbar
            inicialyOpenned={props.inicialyOpenned}
            active={Boolean(filter)}
        >
            <FormProvider {...FormMethods}>
                <UnForm handleSubmit={hadleFilterFormSubmit} usingContext>
                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <UnForm.LazySelect
                            className="form-control"
                            name="ID_EMPREENDIMENTO"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                        />
                    </div>

                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <UnForm.SubmitButton
                            color="primary"
                            noDiv={true}
                            icon={faFilter}
                            loading={props.loading}
                            loadingSize="sm"
                            type="submit"
                            className="btn btn-block btn-outline-dark"
                        >
                            Filtrar
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
